"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useChipStyle = ({ selected }) => {
    const theme = (0, material_1.useTheme)();
    const chip = {
        borderRadius: '8px',
        minWidth: '110px',
        background: selected ? theme.qlub.palette.iris_light.main : theme.qlub.palette.white.main,
        color: selected ? theme.qlub.palette.iris.main : theme.qlub.palette.onSurfaceColors.highEmphasis,
        '.MuiChip-icon': {
            height: !selected ? '1rem' : '1.25rem',
            color: selected && theme.qlub.palette.iris.main,
        },
        '&.MuiChip-outlined': {
            borderColor: theme.qlub.palette.dim.main,
            '&:hover': {
                cursor: 'pointer',
                border: !selected
                    ? `1px solid ${theme.qlub.palette.onSurfaceColors.mediumEmphasis}`
                    : `1px solid ${theme.qlub.palette.dim.main}`,
            },
            '&:focus': {
                border: !selected
                    ? `1px solid ${theme.qlub.palette.onSurfaceColors.mediumEmphasis}`
                    : `1px solid ${theme.qlub.palette.dim.main}`,
            },
        },
    };
    return {
        chip,
    };
};
exports.default = useChipStyle;
